import React from 'react';
import Button from '@material-ui/core/Button';
import { t } from 'ttag';
import { useMutation } from '@apollo/react-hooks';

import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import { gql } from 'apollo-boost';
import useNotifier from '../Messages/hooks';

import FormField from '../FormField';
import Form from '../Form';

export const changePasswordMutation = gql`
  mutation changePassword($userId: Int!, $password: String!) {
    changePassword(userId: $userId, password: $password) {
      ok
      errors {
        field
        messages
      }
    }
  }
`;

const ChangePasswordDialog = ({ userId }) => {
  const pushMessage = useNotifier();
  const [open, setOpen] = React.useState(false);
  const [state, setState] = React.useState({});

  const [changePassword] = useMutation(changePasswordMutation, {
    onCompleted: (d) => {
      const { changePassword } = d;
      if (changePassword.ok) {
        handleClose();
        pushMessage({ text: t`Пароль успішно змінено` });
      } else {
        setState({ ...state, errors: changePassword.errors });
      }
    },
  });

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  const onSubmit = (formData) => {
    if (!formData.password || !formData.checkPassword) {
      pushMessage({ text: t`Введіть пароль` });
    }
    if (formData.password !== formData.checkPassword) {
      pushMessage({ text: t`Паролі не співпадають` });
    }
    changePassword({ variables: { userId, password: formData.password } });
  };

  return (
    <div>
      <Button variant='outlined' color='primary' onClick={handleClickOpen}>
        {t`Змінити пароль`}
      </Button>
      <Dialog
        open={open}
        onClose={handleClose}
        aria-labelledby='alert-dialog-title'
        aria-describedby='alert-dialog-description'
      >
        <Form
          onSubmit={onSubmit}
          initial={{
            password: '',
            checkPassword: '',
          }}
          errors={[]}
        >
          {({ data, change, errors, submit }) => (
            <>
              <DialogTitle id='alert-dialog-title'>Змінити пароль</DialogTitle>
              <DialogContent>
                <DialogContentText id='alert-dialog-description'>
                  <FormField
                    required
                    fullWidth
                    type='password'
                    margin='normal'
                    label={t`Новий пароль`}
                    id='password'
                    name='password'
                    variant='outlined'
                    value={data.password}
                    errors={errors.password}
                    onChange={change}
                  />
                  <FormField
                    required
                    fullWidth
                    type='password'
                    margin='normal'
                    label={t`Повторіть пароль`}
                    id='checkPassword'
                    name='checkPassword'
                    variant='outlined'
                    value={data.checkPassword}
                    errors={errors.checkPassword}
                    onChange={change}
                  />
                </DialogContentText>
              </DialogContent>
              <DialogActions>
                <Button
                  style={{ margin: '20px 0 20px 0' }}
                  margin='normal'
                  type='button'
                  variant='contained'
                  color='primary'
                  onClick={submit}
                >
                  {t`Зберегти`}
                </Button>

                <Button onClick={handleClose} color='primary' autoFocus>
                  {t`Відмінити`}
                </Button>
              </DialogActions>
            </>
          )}
        </Form>
      </Dialog>
    </div>
  );
};

export default ChangePasswordDialog;
